(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/use-notify-updated-balance.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/use-notify-updated-balance.js');
"use strict";

const {
  isFulfilled
} = RTK;
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  useEffect,
  useCallback,
  useState
} = React;
const {
  fetchMarketplacePlayerWallets,
  fetchMarketplaceRetailWallet
} = svs.components.tipsen.wallet.actions;
const {
  CurrencyFromJupiterString
} = svs.utils.format;
const {
  showIncreaseWarning
} = svs.components.marketplace.accountSelector.helpers;
const {
  recountRetailBalance
} = svs.components.marketplace.retailCommissionCounter;
const {
  selectActiveWallet
} = svs.components.tipsen.walletSelectors;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  PARAM_MARKETPLACE_GAME_ID
} = svs.components.sport.tipsenShared;
const {
  useQueryParam
} = svs.components.lbUtils;
const {
  WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER
} = svs.components.tipsen.wallet.walletType;
const useNotifyUpdatedBalance = function () {
  let skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const wallet = useSelector(selectActiveWallet);
  const dispatch = useDispatch();
  const {
    productId,
    drawNumber
  } = useCurrentDraw();
  const marketplaceGame = useQueryParam(PARAM_MARKETPLACE_GAME_ID);
  const [currentShares, setCurrentShares] = useState(() => {
    if (isMarketplaceWallet(wallet)) {
      if (wallet.type === WALLET_MARKETPLACE_RETAILER) {
        return wallet.meta.soldShares;
      }
      return Math.floor(CurrencyFromJupiterString(wallet.meta.Balance) / CurrencyFromJupiterString(wallet.meta.SharePrice));
    }
    return -1;
  });
  useEffect(() => {
    if (isMarketplaceWallet(wallet)) {
      if (wallet.type === WALLET_MARKETPLACE_RETAILER) {
        setCurrentShares(wallet.meta.soldShares);
      } else {
        setCurrentShares(Math.floor(CurrencyFromJupiterString(wallet.meta.Balance) / CurrencyFromJupiterString(wallet.meta.SharePrice)));
      }
    }
  }, [wallet]);
  const notifyUpdatedBalance = useCallback(async () => {
    if (!isMarketplaceWallet(wallet) || skip) {
      return;
    }

    const buyCloseTime = new Date(wallet.meta.BuyinCloseTime);
    if (buyCloseTime < new Date()) {
      return;
    }
    const calculateNewShares = async () => {
      if (wallet.type === WALLET_MARKETPLACE_PLAYER) {
        const result = await dispatch(fetchMarketplacePlayerWallets({
          productId,
          drawNumber
        }));
        if (isFulfilled(result)) {
          const game = result.payload.find(activatedDraw => activatedDraw.ActivatedDrawId === wallet.id);

          if (!game) {
            return;
          }
          const updatedSharePrice = CurrencyFromJupiterString(game.SharePrice);
          const updatedBalance = CurrencyFromJupiterString(game.Balance);
          const updatedShares = Math.floor(updatedBalance / updatedSharePrice);
          if (updatedShares > currentShares) {
            return {
              shares: updatedShares - currentShares,
              balance: updatedBalance
            };
          }
        }
      } else {
        const result = await dispatch(fetchMarketplaceRetailWallet(marketplaceGame));
        if (isFulfilled(result)) {
          const updatedSharePrice = CurrencyFromJupiterString(result.payload.sharePrice);
          const updatedBalance = recountRetailBalance(result.payload.soldShares, updatedSharePrice, wallet.meta.commissionPercent);
          if (result.payload.soldShares > currentShares) {
            return {
              shares: result.payload.soldShares - currentShares,
              balance: updatedBalance
            };
          }
        }
      }
    };
    const result = await calculateNewShares();
    if (!result) {
      return;
    }
    return new Promise(resolve => {
      showIncreaseWarning(result.shares, result.balance, () => {
        resolve();
      });
    });
  }, [wallet, dispatch, drawNumber, productId, currentShares, marketplaceGame, skip]);
  return notifyUpdatedBalance;
};
setGlobal('svs.components.tipsen.couponId.useNotifyUpdatedBalance', useNotifyUpdatedBalance);

 })(window);